import { useDataLoader } from "2g-hooks/fetch";

import { DATA } from "b2b/api/paths";

export default function useZakaznik({ ico }) {
  return useDataLoader({
    url: DATA.zakaznik(ico),
    method: "get"
  });
}
